import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root', // Makes the service available app-wide
})
export class ButtonStateService {
  private isButtonDisabledSubject = new BehaviorSubject<boolean>(false);
  isButtonDisabled$ = this.isButtonDisabledSubject.asObservable();

  setButtonDisabled(state: boolean): void {
    this.isButtonDisabledSubject.next(state);
  }

  getButtonDisabled(): boolean {
    return this.isButtonDisabledSubject.getValue();
  }
}
